import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/index";
import { Panel } from "../store/openedPanel";
import {
  clearSelectedPlacement,
  setSelectedPlacement,
} from "../store/selectedPlacement";
import * as OpenedPanel from "../store/openedPanel";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { gotoHome, gotoProfile } from "../services/routing";
import { PlacementId } from "../types/Placement";
import { usePlacementPath } from "./usePlacementPath";
export type { TopPanel, BottomPanel, Panel } from "../store/openedPanel";

export const usePanelDisclosure = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const openedPanel = useSelector((state: RootState) => state.openedPanel);
  const getPlacementPath = usePlacementPath();
  const { orgPath } = useParams();

  const isOpen = React.useCallback(
    (panel: Panel) => {
      return openedPanel[panel];
    },
    [openedPanel]
  );

  const open = React.useCallback(
    (panel: Exclude<Panel, "placementProfile" | "miniPlacementCard">) => {
      dispatch(OpenedPanel.open(panel));
    },
    [dispatch]
  );

  const close = React.useCallback(
    (panel: Exclude<Panel, "placementProfile" | "miniPlacementCard">) => {
      dispatch(OpenedPanel.close(panel));
    },
    [dispatch]
  );

  const closeTopPanel = React.useCallback(() => {
    dispatch(OpenedPanel.closeTopPanel());
  }, [dispatch]);

  const openPlacementProfile = React.useCallback(
    (placementId: PlacementId) => {
      gotoProfile(navigate, location, getPlacementPath(placementId))();
      dispatch(setSelectedPlacement(placementId));
      dispatch(OpenedPanel.open("placementProfile"));
      dispatch(OpenedPanel.close("filter"));
      dispatch(OpenedPanel.close("miniPlacementCard"));
    },
    [dispatch, getPlacementPath, navigate, location]
  );

  const closePlacementProfile = React.useCallback(() => {
    gotoHome(navigate, location, orgPath);
    dispatch(clearSelectedPlacement());
    dispatch(OpenedPanel.close("placementProfile"));
  }, [dispatch, navigate, location, orgPath]);

  const openMiniPlacementCard = React.useCallback(
    (placementId: PlacementId) => {
      dispatch(setSelectedPlacement(placementId));
      dispatch(OpenedPanel.open("miniPlacementCard"));
    },
    [dispatch]
  );

  const closeMiniPlacementCard = React.useCallback(() => {
    dispatch(clearSelectedPlacement());
    dispatch(OpenedPanel.close("miniPlacementCard"));
  }, [dispatch]);

  const closeAll = React.useCallback(() => {
    dispatch(OpenedPanel.closeAll());
  }, [dispatch]);

  return {
    isOpen,
    close,
    open,
    closeTopPanel,
    openPlacementProfile,
    closePlacementProfile,
    openMiniPlacementCard,
    closeMiniPlacementCard,
    closeAll,
  };
};
